import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { isNumber } from '@grandvisionhq/utils';
import Card from '../Card/Card.js';
import Price from '../Price/Price.js';
import Button from '../Button/Button.js';

const PriceComponent = ({ priceIsZeroLabel , originalPrice , price , currency ,  })=>{
    if (price === 0) {
        return /*#__PURE__*/ React.createElement(Card.Text, {
            variant: "caption"
        }, priceIsZeroLabel);
    }
    const isDiscounted = isNumber(originalPrice) && originalPrice > 0 && originalPrice !== price;
    return /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "caption",
        className: "line-item-bundle-row__price"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: price,
        currency: currency
    }), isDiscounted ? /*#__PURE__*/ React.createElement(Price, {
        type: "strikethrough",
        currency: currency,
        value: originalPrice
    }) : null);
};
var LineItemBundleRow = (props)=>{
    const { title , body , action  } = props, priceInfo = swcHelpers.objectWithoutProperties(props, [
        "title",
        "body",
        "action"
    ]);
    const { getLabel  } = useIntl();
    const priceIsZeroLabel = priceInfo.priceIsZeroLabel || getLabel('cart.lineItem.glasses.isIncluded', {
        hideLabelKey: true
    });
    return /*#__PURE__*/ React.createElement(Card.Section, {
        className: "line-item-bundle-row__section"
    }, /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "none"
    }, title && /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "caption-head"
    }, title), /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "caption"
    }, body), action && /*#__PURE__*/ React.createElement(Button, {
        className: "line-item-bundle-row__action",
        variant: "ghost",
        onClick: action.onClick,
        size: "small",
        caption: action.text
    })), /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "none"
    }, /*#__PURE__*/ React.createElement(PriceComponent, swcHelpers.extends({}, priceInfo, {
        priceIsZeroLabel: priceIsZeroLabel
    }))));
};

export { LineItemBundleRow };
//# sourceMappingURL=LineItemBundleRow.js.map
